import SEO, { breadcrumbSchema } from '@/components/SEO';

const MentionsLegales = () => {
  return (
    <section className="section-padding bg-background">
      <SEO
        title="Mentions légales — Cygnature Production"
        description="Mentions légales du site Cygnature Production : éditeur, hébergeur, propriété intellectuelle et données personnelles."
        path="/mentions-legales"
        jsonLd={[breadcrumbSchema([{ name: 'Accueil', path: '/' }, { name: 'Mentions légales', path: '/mentions-legales' }])]}
      />
      <div className="max-w-3xl mx-auto prose prose-sm">
        <h1 className="font-heading text-3xl font-bold text-foreground">Mentions légales</h1>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">1. Éditeur du site</h2>
        <p className="text-muted-foreground">
          Le site internet est édité par la SARL <strong className="text-foreground">B-TO CORP</strong>, au capital social de 5 000 euros, dont le siège social est situé : Ilot Quai 8.2, Bâtiment E1, 31 Rue d'Armagnac, 33800 Bordeaux, France, immatriculée au RCS de Bordeaux 99319037000011.
        </p>
        <ul className="text-muted-foreground list-disc pl-6 space-y-1">
          <li>Directeur de la publication : <a href="https://b-to.io/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">B-TO CORP</a></li>
          <li>Email : <a href="mailto:contact@b-to.io" className="text-primary hover:underline">contact@b-to.io</a></li>
          <li>Téléphone : 05 54 54 65 29</li>
        </ul>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">2. Hébergement du site</h2>
        <p className="text-muted-foreground">
          Le site est hébergé par OVH, SAS au capital de 10 174 560 €, siège social : 2 rue Kellermann, 59100 Roubaix, France. Téléphone : +33 (0)9 72 10 10 07. Site web : <a href="https://www.ovh.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.ovh.com</a>
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">3. Objet du site</h2>
        <p className="text-muted-foreground">Présentation des activités et services de Cygnature Production.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">4. Propriété intellectuelle</h2>
        <p className="text-muted-foreground">Tous les éléments du site (textes, images, logos, vidéos, etc.) sont la propriété exclusive de Cygnature Production. Toute reproduction ou exploitation non autorisée est interdite.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">5. Liens hypertextes</h2>
        <p className="text-muted-foreground">Toute mise en place de lien vers le site nécessite une autorisation écrite préalable. Cygnature Production décline toute responsabilité pour le contenu des sites externes.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">6. Données personnelles et cookies</h2>
        <p className="text-muted-foreground">
          Des cookies peuvent être installés automatiquement. L'utilisateur peut les accepter, refuser ou paramétrer via son navigateur. Conformément à la loi Informatique et Libertés et au RGPD, l'utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles : <a href="mailto:contact@cygnatureproduction.fr" className="text-primary hover:underline">contact@cygnatureproduction.fr</a>
        </p>
        <p className="text-muted-foreground">
          Pour plus d'informations, consultez notre <a href="/politique-de-confidentialite" className="text-primary hover:underline">Politique de confidentialité</a>.
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">7. Responsabilité</h2>
        <p className="text-muted-foreground">L'utilisateur doit disposer des compétences et moyens nécessaires pour accéder et utiliser le site. Cygnature Production ne peut être tenue responsable d'erreurs, omissions ou indisponibilités temporaires du site.</p>
      </div>
    </section>
  );
};

export default MentionsLegales;
